import Slide from '../../utils/Slide';
import { useCarousel } from '../../hooks/useCarousel';
import { ChevronLeft, ChevronRight, PauseIcon, Play } from 'lucide-react';

const slides = [
  {
    image: '/images/categories-hero-banners/categories-slide-1.svg',
    imageMobile:
      '/images/categories-hero-banners/categories-slide-1-mobile.svg',
    content: (
      <>
        {/* <h1 className="text-3xl font-bold">Slide One</h1> */}
        {/* <p className="text-sm mt-2">Enjoy deals on home products</p> */}
      </>
    ),
  },
  {
    image: '/images/categories-hero-banners/categories-slide-2.svg',
    imageMobile:
      '/images/categories-hero-banners/categories-slide-2-mobile.svg',
    content: (
      <>
        {/* <h1 className="text-3xl font-bold">Slide Two</h1>
        <p className="text-sm mt-2">Explore electronics & more</p> */}
      </>
    ),
  },
  {
    image: '/images/categories-hero-banners/categories-slide-3.svg',
    imageMobile:
      '/images/categories-hero-banners/categories-slide-3-mobile.svg',
    content: (
      <>
        {/* <h1 className="text-3xl font-bold">Slide Two</h1>
        <p className="text-sm mt-2">Explore electronics & more</p> */}
      </>
    ),
  },
];

export default function HeroBanner({
  slides = [],
  height = 360,
  autoSlideInterval = 3000,
  categoriesBanner,
}) {
  const { currentIndex, nextSlide, prevSlide, isPaused, togglePause } =
    useCarousel({ slideCount: slides.length, autoSlideInterval });

  return (
    <section className="md:mt-10 mt-8">
      <div
        className="w-full relative overflow-hidden bg-[#F5F5F7]"
        style={{ height }}
      >
        {slides.map((slide, index) => (
          <Slide
            key={index}
            slide={slide}
            isActive={index === currentIndex}
            categoriesBanner={categoriesBanner}
          />
        ))}

        <div className="absolute bottom-4 right-4 flex gap-2 z-20">
          <button
            aria-label="previous"
            onClick={prevSlide}
            className="w-8 h-[22px] bg-white rounded-[10px] flex items-center justify-center"
          >
            <ChevronLeft size={10} />
          </button>
          <button
            aria-label="next"
            onClick={nextSlide}
            className="w-8 h-[22px] bg-white rounded-[10px] flex items-center justify-center"
          >
            <ChevronRight size={10} />
          </button>
          <button
            aria-label="play or pause"
            onClick={togglePause}
            className="w-8 h-[22px] bg-white rounded-[10px] flex items-center justify-center"
          >
            {!isPaused ? (
              <PauseIcon size={10} fill="black" />
            ) : (
              <Play size={10} fill="black" />
            )}
          </button>
        </div>
      </div>
    </section>
  );
}
